import * as React from 'react';
import * as styles from './Layout.css';

export const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['layout']}>{children}</div>;
};
